import * as React from "react";
import type { SVGProps } from "react";
const SvgBubbleWithEllipsis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.29 12.71c.19.18.45.29.71.29s.52-.11.71-.29c.19-.19.29-.45.29-.71s-.1-.52-.29-.71c-.28-.28-.73-.36-1.09-.21-.13.05-.23.12-.33.21-.18.19-.29.45-.29.71s.11.52.29.71M12 13c-.26 0-.52-.11-.71-.29l-.12-.15a.8.8 0 0 1-.09-.18.6.6 0 0 1-.06-.18 1 1 0 0 0-.01-.1q-.009-.048-.01-.1c0-.06 0-.13.02-.19.01-.07.03-.13.06-.19q.03-.09.09-.18l.12-.15c.37-.37 1.05-.37 1.42 0l.042.05a.757.757 0 0 1 .168.28c.03.06.05.12.06.19.01.06.02.13.02.19 0 .07 0 .13-.02.2 0 .06-.03.12-.06.18a.8.8 0 0 1-.168.28l-.042.05c-.19.18-.45.29-.71.29M14.29 12.71c.19.18.45.29.71.29s.52-.11.71-.29c.19-.19.29-.45.29-.71s-.1-.52-.29-.71c-.37-.37-1.05-.37-1.42 0-.18.19-.29.45-.29.71s.11.52.29.71"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.26 21.67a.98.98 0 0 0 1.1.26l4.45-1.71c1.32.58 2.73.88 4.19.88 5.51 0 10-4.28 10-9.55S17.51 2 12 2 2 6.28 2 11.55c0 1.97.65 3.9 1.83 5.5l-1.73 3.5c-.18.37-.12.82.16 1.12M4 11.55C4 7.39 7.59 4 12 4s8 3.4 8 7.56-3.59 7.55-8 7.55c-1.3 0-2.55-.3-3.71-.87a.97.97 0 0 0-.8-.04l-2.46.95.88-1.78c.17-.36.12-.79-.14-1.09C4.61 14.92 4 13.29 4 11.55"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBubbleWithEllipsis;
